import React from 'react';
import { Link } from 'react-router-dom';

import Swal from 'sweetalert2';
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import {
	FormGroup,
	FormLabel,
	Tooltip,
	TextField,
	Button,
	Select,
	FormControl,
	InputLabel,
} from '@material-ui/core';
import $ from 'jquery'
import { getAllParts, getAdminArea } from '../../actions/homeAction';
import { FaEdit } from 'react-icons/fa';

class SparePartMaster extends React.Component {
	// constructor() {
	// 	super();
	// 	this.state = {};
	// }
	state = {};
	handleStatusChange = (sid, status) => {
		// var isChecked = $('#cattogBtn_' + sid);
		// isChecked.prop('checked', !isChecked.prop('checked'));
		// // console.log(isChecked.prop('checked'), !isChecked.prop('checked'));
		// if (!isChecked.prop('checked') === true) {
		// 	var status = 'active';
		// } else {
		// 	var status = 'inactive';
		// }
		// let newArray = this.state.user_list;
		// var a = newArray.find(element => {
		// 	return element.id === sid;
		// });
		// a.status = status;
		// // console.log(newArray);
		// this.setState({ user_list: newArray });
		// Swal.fire('Update Status!', 'Status has been updated.', 'success');
	};

	componentDidUpdate(prevProps) {
		// console.log('hello 1', prevProps);

		if (prevProps.location.pathname !== this.props.location.pathname) {
			// console.log('hello 2');
			if (this.props.match.params.type === 'CarName') {
			} else if (this.props.match.params.type === 'CarArea') {
				this.props.getAdminArea();
			} else if (this.props.match.params.type === 'SpareParts') {
				this.props.getAllParts();
			} else if (this.props.match.params.type === 'SparePartTypes') {
			}
		}
	}

	componentDidMount() {
		if (this.props.match.params.type === 'CarName') {
		} else if (this.props.match.params.type === 'CarArea') {
			this.props.getAdminArea();
		} else if (this.props.match.params.type === 'SpareParts') {
			this.props.getAllParts();
		} else if (this.props.match.params.type === 'SparePartTypes') {
		}
	}

	render() {
		let columns = [];

		// if (this.props.match.params.type === 'CarName') {
		// 	columns = [
		// 		{
		// 			name: 'CarName',
		// 			label: 'Car Name',
		// 			options: {
		// 				filter: false,
		// 				sort: true,
		// 			},
		// 		},
		// 		{
		// 			name: 'Description',
		// 			label: 'Description',
		// 			options: {
		// 				filter: false,
		// 				sort: true,
		// 			}
		// 		},
		// 		{
		// 			name: 'Priority',
		// 			label: 'Priority',
		// 			options: {
		// 				filter: false,
		// 				sort: true,
		// 			},
		// 		},
		// 		{
		// 			name: 'status',
		// 			label: 'Status',
		// 			options: {
		// 				filter: true,
		// 				sort: true,
		// 				customBodyRender: (status, tableMeta) => {
		// 					var Id = tableMeta.rowData[3];
		// 					// console.log('parts table', tableMeta.rowData[3]);
		// 					return (
		// 						<Toggle
		// 							id={'status_' + Id}
		// 							checked={status}
		// 							value={status}
		// 							onChange={this.handleStatusChange.bind(this, Id, status)}
		// 						/>
		// 					);
		// 				},
		// 			},
		// 		},
		// 		// {
		// 		// 	name: 'Visibility',
		// 		// 	label: 'Visibility',
		// 		// 	options: {
		// 		// 		filter: false,
		// 		// 		sort: true,
		// 		// 	},
		// 		// },
		// 	];
		// } else 
		// if (this.props.match.params.type === 'CarArea') {
		// 	columns = [
		// 		{
		// 			name: 'area',
		// 			label: 'Car Area',
		// 			options: {
		// 				filter: false,
		// 				sort: true,
		// 			},
		// 		},
		// 		// {
		// 		// 	name: 'Description',
		// 		// 	label: 'Description',
		// 		// 	options: {
		// 		// 		filter: false,
		// 		// 		sort: true,
		// 		// 	},
		// 		// },
		// 		// {
		// 		// 	name: 'Priority',
		// 		// 	label: 'Priority',
		// 		// 	options: {
		// 		// 		filter: false,
		// 		// 		sort: true,
		// 		// 	},
		// 		// },
		// 		{
		// 			name: 'active',
		// 			label: 'Status',
		// 			options: {
		// 				filter: true,
		// 				sort: true,
		// 				customBodyRender: (active, tableMeta) => {
		// 					var Id = tableMeta.rowData[3];
		// 					// console.log('parts table', tableMeta.rowData[3]);
		// 					return (
		// 						<Toggle
		// 							id={'status_' + Id}
		// 							checked={active}
		// 							value={active}
		// 							onChange={this.handleStatusChange.bind(this, Id, active)}
		// 						/>
		// 					);
		// 				},
		// 			},
		// 		},
		// 		// {
		// 		// 	name: 'Visibility',
		// 		// 	label: 'Visibility',
		// 		// 	options: {
		// 		// 		filter: false,
		// 		// 		sort: true,
		// 		// 	},
		// 		// },
		// 	];
		// } else
		 if (this.props.match.params.type === 'SpareParts') {
			columns = [
				{
					name: 'name',
					label: 'Spare Part Name (En)',
					options: {
						filter: false,
						sort: true,
					},
				},
				{
					name: 'nameAr',
					label: 'Spare Part Name (Ar)',
					options: {
						filter: false,
						sort: true,
					},
				},
				{
					name: 'medium',
					label: 'Spare Part Image',
					options: {
						filter: false,
						sort: true,
						customBodyRender: (medium, tableMeta) => {
							return (
								<img src={medium?.path} width={60} alt='no img'/>
							);
						},
					},
				},
				{
					name: 'status',
					label: 'Status',
					options: {
						filter: true,
						sort: true,
						customBodyRender: (status, tableMeta) => {
							var Id = tableMeta.rowData[4];
							console.log("Id",Id);
							
							return (
								<Toggle
									id={'status_' + Id}
									checked={status}
									value={status}
									onChange={this.handleStatusChange.bind(this, Id, status)}
								/>
							);
						},
					},
				},
				{
					name: 'partId',
					label: 'Action',
					options: {
						filter: true,
						sort: true,
						customBodyRender: (partId) => {
							return (
								<div>
									<Link to={`/SparePartMaster/SpareParts/Update/${partId}?`}><FaEdit style={{fontSize: '1.4rem'}} /></Link>
								</div>
							);
						},
					},
				},
			];
		} else if (this.props.match.params.type === 'SparePartTypes') {
			columns = [
				{
					name: 'SpartPartType',
					label: 'Spart Part Type',
					options: {
						filter: false,
						sort: true,
					},
				},
				{
					name: 'SparePartName',
					label: 'Spare Part Name',
					options: {
						filter: false,
						sort: true,
					},
				},
				{
					name: 'status',
					label: 'Status',
					options: {
						filter: true,
						sort: true,
						customBodyRender: (status, tableMeta) => {
							var Id = tableMeta.rowData[3];
							// console.log('parts table', tableMeta.rowData[3]);
							return (
								<Toggle
									id={'status_' + Id}
									checked={status}
									value={status}
									onChange={this.handleStatusChange.bind(this, Id, status)}
								/>
							);
						},
					},
				},
			];
		} else if (this.props.match.params.type === 'SpareProducts') {
			columns = [
				{
					name: 'SpartPartType',
					label: 'Spart Products',
					options: {
						filter: false,
						sort: true,
					},
				},
				{
					name: 'SparePartName',
					label: 'Spare Product Name',
					options: {
						filter: false,
						sort: true,
					},
				},
				{
					name: 'status',
					label: 'Status',
					options: {
						filter: true,
						sort: true,
						customBodyRender: (status, tableMeta) => {
							var Id = tableMeta.rowData[3];
							// console.log('parts table', tableMeta.rowData[3]);
							return (
								<Toggle
									id={'status_' + Id}
									checked={status}
									value={status}
									onChange={this.handleStatusChange.bind(this, Id, status)}
								/>
							);
						},
					},
				},
			];
		}

		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					noMatch: this.state.isSaving
						? 'Loading data..!'
						: 'Sorry, No Data Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
		
	// console.log("SpareAllParts", this.props.match.params.type)
		return (
			<div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										{/* <h5>Product {this.props.match.params.type} List</h5> */}
										<Link
											to={`/SparePartMaster/${this.props.match.params.type}/Add/${this.props.match.params.type}`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											{`Add ${this.props.match.params.type} `}
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{/* <button
												className='f-right bg-white b-none'
												data-modal='modal-13'>
												<Tooltip
													title='Download Selected'
													aria-label='download'
													onClick={() => {
														this.exportCSVS();
													}}>
													<i
														className='icofont icofont-download-alt'
														style={{
															fontSize: '30px',
															color: 'grey',
														}}></i>
												</Tooltip>
											</button> */}

											<MUIDataTable
												title={`${this?.props?.match?.params?.type} List`}
												className='table-responsive'
												data={this.props.SpareAllParts}
												columns={columns}
												options={options}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

SparePartMaster.propsTypes = {
	getAdminArea: PropTypes.func.isRequired,
};

var mapStateToProps = state => ({
	SpareAllParts: state?.home?.allSparePartsList?.response
	// areaList: state?.home?.AdminAreaList?.response,
});

export default connect(mapStateToProps, { getAllParts, getAdminArea })(
	SparePartMaster
);
